'use client';
import { FaWhatsapp } from 'react-icons/fa';

export default function WhatsAppButton() {
  const phoneNumber = '+918802133490'; // Replace with your number
  const message = 'Hello! I have a question about your services.';

  return (
    <div className="fixed left-4 bottom-4 z-50 flex items-center">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:bg-[#128C7E]"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="text-xl" />
      </a>

      {/* Speech Bubble with Tail (now on right side) */}
      <div className="relative ml-2">
        <div className="bg-white rounded-lg shadow-md px-3 py-2">
          <span className="text-sm font-medium text-gray-800">Chat with us!</span>
        </div>
        {/* Bubble Tail pointing left */}
        <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45"></div>
      </div>
    </div>
  );
}